<template>
    <div class="insurance">
        <section class="section page-wrapper insurance__section">
            <div class="section__content">
                <h1 class="section__heading">
                    {{ $t('pages.insurance.heading') }}
                </h1>

                <div class="section__part intro-part">
                    <p class="section__intro">
                        {{ $t('pages.insurance.intro1') }}
                    </p>
                    <p>
                        {{ $t('pages.insurance.intro2') }}
                    </p>
                </div>
                <div class="insurance--list">
                    <div
                        v-for="insurance in insuranceTypes"
                        :key="insurance.name"
                        class="insurance--list-item"
                        @click="navigateToInsuranceDetails(insurance.path)"
                    >
                        <div :class="['header', insurance.name]">
                            <img v-if="insurance.logoSrc" :src="insurance.logoSrc" :alt="insurance.name" />
                            <div v-if="insurance.title">{{ insurance.title }}</div>
                        </div>
                        <div class="description">
                            {{ insurance.description }}
                        </div>
                    </div>
                </div>

                <div class="section__cta-buttons">
                    <LocalizedLink :to="{ name: 'rent-out' }" class="button button--secondary-contrast">
                        {{ $t('pages.insurance.rent_out_btn_label') }}
                    </LocalizedLink>
                    <LocalizedLink
                        :to="
                            localePath({
                                path: `/${$t('common.motorhomes_page_path')}`,
                                query: { [$t('common.all_vehicles_query')]: 1 },
                            })
                        "
                        class="button button--primary"
                    >
                        {{ $t('pages.insurance.vehicles_btn_label') }}
                    </LocalizedLink>
                </div>
            </div>
            <Contact />
        </section>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Contact from '~/components/sections/Contact.vue';

export default {
    components: {
        Contact,
    },
    head() {
        return {
            title: this.$t('pages.insurance.page_title'),
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: this.$t('pages.insurance.page_description'),
                },
            ],
        };
    },
    nuxtI18n: {
        paths: {
            se: '/forsakring',
            'fi-sv': '/forsakring',
            en: '/insurance',
            de: '/versicherung',
            at: '/versicherung',
            fi: '/vakuutus',
            no: '/forsikring',
            dk: '/forsikring',
            ch: '/versicherung',
            fr: '/assurance',
        },
    },
    computed: {
        ...mapGetters(['siteCountryCode']),
        insuranceTypes() {
            const insuranceTypes = [
                {
                    name: 'baloise',
                    logoSrc: require('~/assets/images/baloise-small.png'),
                    description: this.$t('pages.insurance.baloise_description'),
                    path: { name: 'insurance-baloise' },
                },
                {
                    name: 'omocom',
                    logoSrc: require('~/assets/images/omocom-logo-small.png'),
                    description: this.$t('pages.insurance.omocom_description'),
                    path: { name: 'insurance-omocom' },
                },
                {
                    name: 'own',
                    title: this.$t('pages.insurance.own_title'),
                    description: this.$t('pages.insurance.own_description'),
                    path: { name: 'insurance-owners-insurance' },
                },
            ];

            return insuranceTypes;
        },
    },
    methods: {
        navigateToInsuranceDetails(path) {
            return this.$router.push(this.localePath(path));
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/sass/blocks/_insurance.scss';
</style>
